// El backend firma, cada vez que el negocio se conecta con éxito (login o
// /auth/me), un token corto con la vigencia de la suscripción y una fecha
// límite (hoy + 15 días) hasta la cual la app puede seguir operando sin
// volver a conectarse. Esto evita que un negocio se quede trabajando
// indefinidamente sin conexión y sin una suscripción activa o vigente.
//
// No hace falta verificar la firma aquí (eso ya lo hace el backend cuando el
// token se usa para algo sensible) — para esta pantalla solo nos interesa
// leer la fecha de vencimiento del propio token, que sí está firmada por el
// servidor y no se puede editar a mano desde el navegador sin invalidarla.

const CLAVE = "vetflow_vigencia_token";

export function guardarVigenciaOffline(token: string) {
  try {
    localStorage.setItem(CLAVE, token);
  } catch {
    // almacenamiento no disponible (modo privado, etc.) — no es crítico
  }
}

export function limpiarVigenciaOffline() {
  localStorage.removeItem(CLAVE);
}

function decodificarPayload(token: string): any | null {
  try {
    const partes = token.split(".");
    if (partes.length !== 3) return null;
    const json = atob(partes[1].replace(/-/g, "+").replace(/_/g, "/"));
    return JSON.parse(decodeURIComponent(escape(json)));
  } catch {
    return null;
  }
}

export interface EstadoVigencia {
  valido: boolean;
  expiraEn: Date | null;
  estadoTenant?: string;
  estadoSuscripcion?: string;
}

export function obtenerEstadoVigencia(): EstadoVigencia {
  const token = localStorage.getItem(CLAVE);
  if (!token) return { valido: false, expiraEn: null };

  const payload = decodificarPayload(token);
  if (!payload?.exp) return { valido: false, expiraEn: null };

  const expiraEn = new Date(payload.exp * 1000);
  const valido = Date.now() < expiraEn.getTime();
  return {
    valido,
    expiraEn,
    estadoTenant: payload.estadoTenant,
    estadoSuscripcion: payload.estadoSuscripcion,
  };
}
